import { GameState } from '../types';
import { CHOP_HITS, TREE_REGROW_TIME } from '../constants';

export function updateTrees(state: GameState, dt: number): void {
  for (const tree of state.trees) {
    // Shake animation
    if (tree.shakeTimer > 0) {
      tree.shakeTimer -= dt;
    }

    // Regrow
    if (tree.hp <= 0 && tree.regrowTimer > 0) {
      tree.regrowTimer -= dt;
      if (tree.regrowTimer <= 0) {
        tree.hp = CHOP_HITS;
        tree.regrowTimer = 0;
      }
    }
  }
}
